import * as $form from './_form'
import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $childaccounts from './account.childaccounts'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $.extend(true, {}, $options)

    $helpers.partialPageInit($('.' + options.pageName))

    elemid('close').click(function () {
        $modal.hide()
    })

    elemid('save').click(function () {
        $ajax.post({
            loadingText: 'Sparar konto...',
            url: '/Account/ChildAccountEditSave',
            data: {
                guid: elemid('guid').val(),
                firstname: elemid('HyITSWXdvlOK').val(),
                lastname: elemid('ker87aviAmrq').val(),
                email: elemid('izSnr4fTQcvW').val(),
                phone: elemid('ld0A9EFeYJSo').val(),
                password1: elemid('password1').val(),
                password2: elemid('password2').val(),
                regions: $form.getCheckboxlistValues(elemid('regions')).join(','),
            },
            success: function (res) {
                if (res.Ok) {
                    $childaccounts.getList()
                    $modal.hide()
                    $msg.show(res.Message)
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })
}

function elem(id: string): JQuery {
    return $(`.${options.pagePrefix}-${id}`)
}

function elemid(id: string): JQuery {
    return $(`#${options.pagePrefix}-${id}`)
}
